<template>
  <b-form-group
    label="Kullanıcı"
    label-for="id_users"
  >
    <v-select
      id="id_users"
      v-model="filterData.id_users"
      :options="users"
      label="title"
      :reduce="user => user.id"
      placeholder="Seçiniz"
      multiple
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'Users',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    filterData() {
      return this.$store.getters['customers/filterData']
    },
    users() {
      return this.$store.getters['users/dataList']
    },
  },
  created() {
    this.getSectors()
  },
  methods: {
    getSectors() {
      this.$store.dispatch('users/getDataList', {
        select: [
          'users.id AS id',
          'users.name AS title',
        ],
      })
    },
  },
}
</script>
